export type BdVirtualClinicGender =
  | 'MALE'
  | 'FEMALE'
  | 'DIVERSE'
  | 'ALL'
  | 'UNKNOWN';

export const BD_VIRTUAL_CLINIC_GENDER_DISPLAY_NAMES: {
  [gender in BdVirtualClinicGender]: string;
} = {
  MALE: 'Männlich',
  FEMALE: 'Weiblich',
  DIVERSE: 'Divers',
  ALL: 'Gesamt',
  UNKNOWN: 'Unbekannt',
};
